import { Box } from 'hephaestus/web';
import { AverageAum } from './averageAum';
import { ManagementFees } from './managementFees';
import { TotalAum } from './totalAum';
import { TotalUsers } from './totalUsers';

export const PracticeOverview = ({
  options = {
    totalAum: false,
    averageAum: false,
    totalClients: false,
    netflows: false,
    managementFees: false,
    fundedClients: false,
    cashPercentage: false,
  },
}: {
  options: {
    totalAum: boolean;
    averageAum: boolean;
    totalClients: boolean;
    netflows: boolean;
    managementFees: boolean;
    fundedClients: boolean;
    cashPercentage: boolean;
  };
}) => {
  const { totalAum, averageAum, totalClients, managementFees, fundedClients } =
    options;
  return (
    <Box
      sx={{
        gap: 2,
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      {totalAum && <TotalAum />}
      {totalClients && <TotalUsers funded={false} />}
      {averageAum && <AverageAum />}
      {fundedClients && <TotalUsers funded={true} />}
      {managementFees && <ManagementFees />}
      {/* TODO: These are not possible due to how the data can be fetched from the search-service. Need to be able to
      aggregate other values besides just marketValueCents, and to be able to scope by array of types for netflows
       */}
      {/* {cashPercentage && (
        <CashPercentage />
      )} */}
      {/* {netflows && (
        <Netflows />
      )} */}
    </Box>
  );
};
